<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">

            <v-data-table :headers="headers" :items="template_list" class="elevation-1 mytable" dense
                :search="search">

                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Course Template</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-row dense justify="center" align="center" class="mx-2 mt-3 mb-1">

                        <v-col cols="12" class="d-flex justify-center">
                            <v-radio-group v-model="status_filter" row dense>
                                <v-radio label="All" value="ALL"></v-radio>

                                <v-radio label="Active" value="ACTIVE"></v-radio>

                                <v-radio label="Inactive" value="INACTIVE"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12" class="d-flex justify-center mb-2">
                            <v-btn color="primary" @click="fetch()" small>
                                Fetch
                            </v-btn>
                        </v-col>

                    </v-row>
                    <span style="width: 20px"></span>

                    <v-row dense align="center">

                        <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2 mt-2 mb-2">
                            <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile">
                                <v-icon left color="success">mdi-export</v-icon>
                                Export
                            </v-btn>
                        </v-col>

                        <v-col class="mr-8" sm="6" md="5" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details />
                        </v-col>

                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" small v-on="on" @click="setDefaultFilters()">
                                    Add Template
                                </v-btn>
                            </template>

                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text class="pb-2 mt-2 pl-7 pr-7">
                                        <v-row dense align="center" justify="center">
                                            <v-col cols="12">
                                                <v-icon color="error" small>*</v-icon>
                                                <v-text-field label="Enter Template Name" v-model="name" outlined
                                                    dense />
                                            </v-col>

                                            <v-col cols="12">
                                                <v-icon color="error" small>*</v-icon>
                                                <v-text-field label="Enter Total Credit" v-model="credit"
                                                    outlined dense type="number" />
                                            </v-col>

                                            <v-col cols="12" v-if="editedIndex !== -1">
                                                <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                    label="Is Active" />
                                            </v-col>
                                        </v-row>
                                    </v-card-text>

                                    <v-card-actions class="justify-center pt-0">
                                        <v-btn class="button" @click="close()" :disabled="!valid">
                                            Cancel
                                        </v-btn>

                                        <v-btn color="primary button" @click="save" :disabled="!valid">
                                            {{ editedIndex === -1 ? 'Save' : 'Update' }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>

                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>

                        <v-avatar size="25" class="delete-avatar ml-2">
                            <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
                        </v-avatar>
                    </div>
                </template>
                 <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template>
                <template v-slot:item.template_details="{ item }">
                    <div class="align-center detail-btn" @click="viewDetails(item)" >
                        <v-icon color="primary" class="mr-1">
                            mdi-arrow-right-bold-box
                        </v-icon>
                    </div>

                </template>
            </v-data-table>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        valid: false,
        overlay: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        status_filter:"ALL",
        max_student: "",
        balance_student: "",
        fees: "",
        subjectgroup: "",
        standard: "",
        stream: "",
        academicyear: "",
        filter_ay: "",
        filter_standard: "",
        filter_stream: "",
        headers: [
            {
                text: "Sr No",
                align: "left",
                sortable: false,
                value: "srno",
            },
            {
                text: "Name",
                align: "center",
                sortable: false,
                value: "name",
            },
            {
                text: "Total Credits",
                align: "center",
                sortable: false,
                value: "credit",
            },
            {
                text: "Template Details",
                align: "center",
                sortable: false,
                value: "template_details",
            },
            {
                text: "Is Active",
                sortable: false,
                value: "isactive",
            },
            {
                text: "Actions",
                value: "action",
                sortable: false
            },
        ],

        template_list: [],
        editedIndex: -1,
        editedItem: {
            id: "",
            name:"",
            credit:"",
            isactive:""

        },
        defaultItem: {
            id: "",
            name:"",
            credit:"",
            isactive:""
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Add Course Template" : "Edit Course Template";
        },
        filteredRuleList() {
            if (!this.search) return this.template_list;

            const txt = this.search.toLowerCase();

            return this.template_list.filter(item => (item.name || "").toLowerCase().includes(txt)
            );
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        }
    },

    methods: {
        downloadFile() {
            this.loader = true;

            const excelData = this.filteredRuleList.map((item, index) => ({
                "S.No": index + 1,
                "Name": item.name,
                "Total Credits": item.credit,
                "Is Active": item.isactive
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Course Template");
            XLSX.writeFile(workbook, "CourseTemplate.xlsx");
            this.loader = false;
        },

        editItem(item) {

            this.editedIndex = this.template_list.indexOf(item);

            this.editedItem = {
                id: item.id,
                name: item.name,
                credit: item.credit,
                isactive: item.isactive
            };
            this.name = item.name,
            this.credit =item.credit,
            this.isactive=item.isactive
            this.dialog = true;
        },

        fetch() {
            if(!this.status_filter){
                this.showSnackbar("#b71c1c", "Select the status ")
                return
            }
            this.overlay = true;
            const data = {
                filter: this.status_filter
            }
            axios
                .post("/admission/getTemplate", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg === "200") {
                        this.overlay = false;
                        this.template_list = res.data.template_list.map((item, index) => ({
                            ...item,
                            srno: index + 1
                        }));

                        if (this.template_list.length <= 0) {
                            this.showSnackbar("#b71c1c", "Templates not present");
                        }
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            this.name="";
            this.credit="";
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
        },

        save() {
            if (!this.isValidated()) {
                return;
            }

            if (this.editedIndex > -1) {
                this.editedItem.name = this.name;
                this.editedItem.credit = this.credit;
                this.editedItem.isactive = this.isactive;
                axios
                    .post("/admission/editTemplate", this.editedItem)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Template Updated Successfully...");
                            this.close();
                            this.fetch();
                        } else if (res.data.code == "NA") {
                            this.showSnackbar("#b71c1c", res.data.msg || "Template Already Present!!!");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            } else {
                const payload = {
                   name : this.name,
                   credit: this.credit
                };
                axios
                    .post("/admission/saveTemplate", payload)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Template Added Successfully...");
                            this.close();
                            this.fetch();
                        } else if (res.data.code == "NA") {
                            this.showSnackbar("#b71c1c", res.data.msg || "Template Already Present!!!");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            }
        },

        isValidated() {

            if (!this.name) {
                this.showSnackbar("#b71c1c", "Enter Template Name...");
                return false;
            }

            if (!this.credit) {
                this.showSnackbar("#b71c1c", "Enter Credits...");
                return false;
            }

            return true;
        },

         toggle(item) {
            const data = {
                id: item.id,
                toggle: item.isactive,
            };
            this.overlay = true;
            axios
                .post("/admission/toggleTemplate", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "Template Updated Successfully!");
                    } else if (res.data.code == "NA") {
                        this.showSnackbar("#4caf50", "Something went wrong, Please try again later!");
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        deleteItem(item) {
            if (confirm("Are you sure you want to delete this Template?")) {
                const data = {
                    id: item.id
                };
                axios
                    .post("/admission/deleteTemplate", data)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Template Deleted Successfully...");
                             this.close();
                            this.fetch();
                        }else if (res.data.code == "DEPENDENCY"){
                            this.showSnackbar("#b71c1c", res.data.msg || "Cannot delete linked in template details");
                        }
                        else {
                            this.showSnackbar("#b71c1c", res.data.msg || "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            }
            this.close();
        },
         
        viewDetails(item) {
            localStorage.setItem("template_id", item.id);

            const routeData = this.$router.resolve({
                name: "template-details"
            });

            window.open(routeData.href, "_blank");
        },
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.mytable /deep/ thead th {
    background: #0f2027;
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}
</style>